import commonSwitch from '@assets/css/common-switch.css';

/**
 * Common switch styles.
 * @type {CSSStyleSheet}
 */
export const commonSwitchStyles = new CSSStyleSheet();
commonSwitchStyles.replaceSync(commonSwitch);
